angular.module('gym.templates').controller('ShowTemplateCtrl', ["$scope", "$modalInstance", "textAngularManager", "template", function($scope, $modalInstance, textAngularManager, template) {
  $scope.template = template;
  return $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
